// extracted by mini-css-extract-plugin
export default {"top-bar":"studio_top-bar__0POH-","studio":"studio_studio__8TGOI","submit-box":"studio_submit-box__yMUOh"};